import type { IconButtonProps } from '@_/ui';
import { PiSlidersHorizontal } from 'react-icons/pi';
import { FormattedMessage } from 'react-intl';
import { buttonCommonI18n } from '@_/i18n-common';
import { Button } from '@_/ui';

interface FiltersButtonProps extends IconButtonProps {}

export function FiltersButton(props: FiltersButtonProps) {
  return (
    <Button iconLeft={<PiSlidersHorizontal />} variant="plain" {...props}>
      <FormattedMessage {...buttonCommonI18n.filters} />
    </Button>
  );
}
